import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ behavior = 'smooth' }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    try {
      if (hash) {
        const id = hash.replace('#', '');
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior });
          return;
        }
      }
      window.scrollTo({ top: 0, behavior });
    } catch (err) {
      // ignore if environment doesn't allow scrolling
    }
  }, [pathname, hash, behavior]);

  return null;
};

export default ScrollToTop;
